var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-setting"},[_c('p',[_vm._v(_vm._s(_vm.$t('lang.k_159001')))]),_c('div',{staticClass:"ai-setting__ft"},[_c('vh-button',{staticClass:"ai-setting-btn",attrs:{"type":"primary","size":"medium","round":""},on:{"click":_vm.goPage}},[_vm._v(" "+_vm._s(_vm.$t('lang.k_159002'))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }